import i18n from '@/plugins/i18n/locale';

/**
 * 電話番号（ハイフン有無不問）
 */
const isValidPhone: any = {
  validate: (value: any): boolean => {
    if (value == null || value === '') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return contains(value);
  },
  message: (field: string, values: any) => {
    values._field_ = `${i18n.t(`form.fields.${field}`)}`;
    return i18n.t(`validations.custom.${values._rule_}`, values);
  }
};

const contains = (c: string): boolean => {
  const re = /^0(\d{1}-?\d{4}|\d{2}-?\d{3}|\d{3}-?\d{2}|\d{4}-?\d{1}|[5789]0-?\d{4})-?\d{4}$/;
  return re.test(c);
};

export default isValidPhone;
